export default{
    apiKey: "AIzaSyBo6FmqIDwbHI1AuV_M7pAr-L4wiYPfUcA",
    authDomain: "shopping-app-6b1ce.firebaseapp.com",
    databaseURL: "https://shopping-app-6b1ce.firebaseio.com",
    projectId: "shopping-app-6b1ce",
    storageBucket: "shopping-app-6b1ce.appspot.com",
    messagingSenderId: "449751535304",
    appId: "1:449751535304:web:30586782e4a265c6fa9ffd",
    measurementId: "G-70GXNG2DM8"
}